/**
 * Shared admin role metadata & tier badge styling.  Used by both
 * Customers and Team tabs so colours stay consistent.
 */
import { Crown, Shield, Eye, ChefHat } from "lucide-react";

export const ROLE_META = {
  root:        { label: "Root",       icon: Crown,   chip: "bg-amber-500 text-slate-950" },
  staff_edit:  { label: "Staff Edit", icon: Shield,  chip: "bg-emerald-500 text-slate-950" },
  staff_view:  { label: "Staff View", icon: Eye,     chip: "bg-sky-500 text-slate-950" },
  // Legacy: anyone still flagged 'staff' renders as edit (Migration 018 backfills).
  staff:       { label: "Staff Edit", icon: Shield,  chip: "bg-emerald-500 text-slate-950" },
  chef:        { label: "Chef",       icon: ChefHat, chip: "bg-slate-700 text-slate-200" },
};

export const ADMIN_ROLES = ["root", "staff_edit", "staff_view"];
export const CHEF_ROLE = "chef";

/**
 * Tier chip classes — neutral indigo for individual (free), gold for professional (paid).
 */
export const TIER_META = {
  individual: {
    label: "Individual",
    chip: "bg-slate-700/70 text-slate-200 border border-slate-600",
  },
  professional: {
    label: "Pro",
    chip: "bg-gradient-to-r from-amber-400 to-yellow-300 text-slate-950 border border-amber-300 shadow-sm shadow-amber-500/30 font-bold",
  },
};

export function TierChip({ tier }) {
  if (!tier) return <span className="text-slate-600 italic text-xs">—</span>;
  const meta = TIER_META[tier] || {
    label: tier,
    chip: "bg-slate-800 text-slate-300 border border-slate-700",
  };
  return (
    <span
      className={
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-[0.65rem] tracking-wide font-semibold " +
        meta.chip
      }
      data-testid={"hq-tier-chip-" + tier}
    >
      {meta.label.toUpperCase()}
    </span>
  );
}

export function RoleChip({ role }) {
  const meta = ROLE_META[role] || ROLE_META.chef;
  const Icon = meta.icon;
  return (
    <span
      className={
        "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[0.65rem] font-semibold tracking-wide " +
        meta.chip
      }
      data-testid={"hq-role-chip-" + role}
    >
      <Icon className="h-2.5 w-2.5" />
      {meta.label.toUpperCase()}
    </span>
  );
}
